import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MultipleSelectFilterSimpleModule
} from "../../../../../../core/component/multiple-select-filter-simple/multiple-select-filter-simple.module";
import {FormGroup} from "@angular/forms";
import {Order, Sort, UrlParameter} from "../../../../../../../shared/utils/url.builder";
import {MedicalToolSetSummaryModel} from "../../entity/medicalToolSetSummary.model";
import {SelectElementV2} from "../../../../../../../components/common/select/selectElementV2";
import {MedicalToolSetSummaryFindAllService} from "../../service/medicalToolSetSummaryFindAll.service";
import {MomentAdapter} from "../../../../../../../shared/utils/moment.utils";

@Component({
  selector: 'app-medical-toolset-select-many',
  standalone: true,
    imports: [CommonModule, MultipleSelectFilterSimpleModule],
  templateUrl: './medical-toolset-select-many.component.html',
  providers: [
    MedicalToolSetSummaryFindAllService
  ]
})
export class MedicalToolsetSelectManyComponent implements OnInit, OnChanges {
  @Input() parentFormGroup: FormGroup;
  @Input() parentFormControlName: string;
  @Input() parameters: UrlParameter[] = [];
  @Input() sort: Sort = new Sort('validationDate', Order.ASCENDING);

  @Output() selectionChangeEvent = new EventEmitter<MedicalToolSetSummaryModel[]>();
  @Output() elementsLoadedEvent = new EventEmitter<MedicalToolSetSummaryModel[]>();

  elements: SelectElementV2<MedicalToolSetSummaryModel>[] = [];

  constructor(public findAllService: MedicalToolSetSummaryFindAllService) {}

  ngOnInit() {
    this.refresh();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['parameters'] && changes['parameters'].firstChange) || changes['sort']) {
      this.refresh();
    }
  }

  refresh() {
    this.elements = [];
    this.findAllService.parameters = this.parameters;
    this.findAllService.sort = this.sort;
    this.findAllService.findAll().then(values => {
      if (values) {
        this.elementsLoadedEvent.emit(values);
        this.elements = values.map(value => {
          return {
            value: value.id,
            label: value.businessIdentifier + '(jusqu\'au ' + MomentAdapter.of(value.validationDate).formatDDMMYYY()  + ')',
            element: value
          };
        });
      }
    });
  }
}
